<template>
<swiper-slide class="swiper1">
  <div class="contanierbox">
    <head-bar :main_title="main_title"></head-bar>
    <div class="data_left">
      <div class="" v-for="(item, index) in leftList" :key="index">
        <h3 class="scale">{{ item.title }}</h3>
        <span class="scale">{{ item.subtitle }}</span>
        <img class="scale" :src="item.src" />
      </div>
    </div>
    <div class="data_right">
      <div class="data_right_tab img_flex" v-show="active == 0"><img class="scale" src="../assets/center/center11.png" width="100%" alt=""></div>
      <div class="data_right_tab img_flex" v-show="active == 1"><img class="scale" src="../assets/center/center22.png" width="100%" alt=""></div>
      <!-- 京东智推 -->
      <div class="data_right_tab" v-show="active == 2">
        <div class="right_top scale">
          <h3>产品研发 - <span>京东智推</span></h3>
          <p>N种交互方式，满足客户多重需求</p>
          <div class="right_img">
            <img src="../assets/center/right_img2.png" width="100%" />
          </div>
        </div>
        <div class="right_bottom">
          <h3 class="scale">客户案例<span>老板电器-京东品牌日</span></h3>
          <ul class="right_list scale">
            <li v-for="(item, index) in rightList" :key="index">
              <h3>{{ item.title }}</h3>
              <span>{{ item.subtitle }}</span>
            </li>
          </ul>
          <div class="clear"></div>
          <div class="tab scale">
            <h2>人口属性分析</h2>
            <!-- 自定义分页器 -->
            <div class="pagination">
              <ul>
                <li
                  @click="bannerTo(index)"
                  @mouseover="mouseEnter"
                  @mouseleave="mouseLeave"
                  class="swiper-pagination-customs"
                  :class="
                    activeIndex == index
                      ? 'swiper-pagination-customs-active'
                      : ''
                  "
                  v-for="(item, index) in pagination"
                  :key="index"
                >
                  {{ item }}
                </li>
              </ul>
              <div class="clear"></div>
            </div>
            <!-- 自定义分页器 -->
          </div>
          <swiper
            :options="swiperOption"
            ref="mySwiper"
            class="mySwiper swiper-no-swiping"
            @slideChange="slideChange"
          >
            <swiper-slide class="swiper1">
              <div id="sexChart" class="scale"></div>
            </swiper-slide>
            <swiper-slide class="swiper2">
              <div id="ageChart" class="scale"></div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <!-- 京东智推 -->
      <div class="data_right_tab img_flex" v-show="active == 3"><img class="scale"  src="../assets/center/center44.png" width="100%" alt=""></div>
      <div class="data_right_tab img_flex" v-show="active == 4"><img class="scale" src="../assets/center/center55.png" width="100%" alt=""></div>
    </div>
    <div class="data_center">
      <div class="center_title scale">全拓-京东生态闭环</div>
      <div class="cir1 scale">
        <img src="../assets/center/cir1.png" width="100%" />
        <div class="center_logo">
          <img src="../assets/center/center_logo.png" width="100%" alt="" />
        </div>
        <div class="c_title">品牌客户服务</div>
      </div>
      <div class="arrow scale">
        <div class="arrow_item arrow_top">
          <img src="../assets/center/arrow_top.png" width="100%" alt="" />
        </div>
        <div class="arrow_item arrow_bottom">
          <img src="../assets/center/arrow_bottom.png" width="100%" alt="" />
        </div>
      </div>
      <div class="cir2 scale">
        <img src="../assets/center/cir2.png" width="100%" alt="" />
        <div class="centerList">
          <div
            v-for="(item, index) in serviceList"
            :key="index"
            @click="changeActive(index)"
          >
            <img :src="item.src" width="100%" alt="" />
            <p>{{ item.title }}</p>
          </div>
        </div>
        <div class="c_title">合作研发升级</div>
      </div>
      <div class="arrowBox scale">
        <div class="arrow">
          <div class="arrow_item arrow_top">
            <img src="../assets/center/arrow_top.png" width="100%" alt="" />
          </div>
          <div class="arrow_item arrow_bottom">
            <img src="../assets/center/arrow_bottom.png" width="100%" alt="" />
          </div>
        </div>
        <div class="arrow">
          <div class="arrow_item arrow_top">
            <img src="../assets/center/arrow_top.png" width="100%" alt="" />
          </div>
          <div class="arrow_item arrow_bottom">
            <img src="../assets/center/arrow_bottom.png" width="100%" alt="" />
          </div>
        </div>
      </div>
      <div class="cir3 scale">
        <img src="../assets/center/cir3.png" width="100%" alt="" />
        <div class="c_title">ISV 全拓软件服务供应商</div>
      </div>
      <div class="jt scale">
        <div class="arrow_down">
          <div class="arrow_item arrow_top">
            <img src="../assets/center/jt1.png" width="100%" alt="" />
          </div>
          <div class="arrow_item arrow_bottom">
            <img src="../assets/center/jt2.png" width="100%" alt="" />
          </div>
        </div>
        <div class="arrow_down">
          <div class="arrow_item arrow_top">
            <img src="../assets/center/jt1.png" width="100%" alt="" />
          </div>
          <div class="arrow_item arrow_bottom">
            <img src="../assets/center/jt2.png" width="100%" alt="" />
          </div>
        </div>
      </div>
      <div class="cir4 scale">
        <img src="../assets/center/cir4.png" width="100%" alt="" />
        <div class="cir4List">
          <div v-for="item in cir4List" :key="item.index">
            <img :src="item.src" width="100%" alt="" />
            <p>{{ item.title }}</p>
          </div>
        </div>
        <div class="c_title">数据底层架构</div>
      </div>
    </div>
  </div>
</swiper-slide>
</template>
<script>
import echarts from "echarts";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import headBar from "../components/headBar.vue";
export default {
  name: "dataCustomer",
  data() {
    return {
      pagination: ["性别", "年龄"], //导航
      activeIndex: 0,
      main_title: require("../assets/center/title.png"),
      leftList: [
        {
          title: "上游供应商",
          subtitle: "头条、抖音、B站、虎牙等",
          src: require("../assets/center/left_img1.png")
        },
        {
          title: "下游客户",
          // subtitle: "电通安吉斯、阳狮、群邑等",
          subtitle: "群邑等",
          src: require("../assets/center/left_img2.png")
        },
        {
          title: "终端客户",
          // subtitle: "比亚迪、移动、飞利浦、原神等",
          subtitle: "比亚迪、移动等",
          src: require("../assets/center/left_img3.png")
        }
      ],
      rightList: [
        {
          title: "总曝光",
          subtitle: "537,281"
        },
        {
          title: "总点击",
          subtitle: "12,611"
        },
        {
          title: "平均CTR",
          subtitle: "2.35%"
        },
        {
          title: "点击完成率",
          subtitle: "126.11%"
        }
      ],
      swiperOption: {
        speed: 800,
        // loop: true,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false // 触摸后继续滚动
        }
      },
      serviceList: [
        {
          src: require("../assets/center/center_item.png"),
          title: "营销云"
        },
        {
          src: require("../assets/center/center_item.png"),
          title: "京准通"
        },
        {
          src: require("../assets/center/center_item_person.png"),
          title: "京东智推"
        },
        {
          src: require("../assets/center/center_item.png"),
          title: "小黑珑"
        },
        {
          src: require("../assets/center/center_item.png"),
          title: "数据营销平台"
        }
      ],
      active: 0,
      timeName: "",
      cir4List: [
        {
          src: require("../assets/center/a.png"),
          title: "全拓数据库"
        },
        {
          src: require("../assets/center/b.png"),
          title: "京东数据库"
        }
      ]
    };
  },
  components: {
    swiper,
    swiperSlide,
    headBar
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    changeActive(index) {
      var that = this;
      that.active = index;
    },
    timeR() {
      var that = this;
      that.timeName = setInterval(() => {
        if (that.active < 4) {
          that.active++;
          // console.log(this.active);
        } else {
          that.active = 0;
        }
      }, 4000);
    },
    // removetimeName() {
    //   clearInterval(this.timeName);
    // },
    sexChart() {
      let myChart = this.$echarts.init(document.getElementById("sexChart"));
      let dataX = ["男", "女"];
      let dataY = [2.41, 2.27];
      let dataY1 = [310000, 225000];
      let option = {
        grid: {
          top: "10%",
          bottom: "15%",
          left: "5%",
          right: "5%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: dataX,
          axisLine: {
            lineStyle: {
              color: "rgba(66, 192, 255, .3)"
            }
          },

          axisLabel: {
            textStyle: {
              color: "#33FFFF"
            }
          }
        },

        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: "#5FBBEB"
              }
            },
            axisLine: {
              lineStyle: {
                fontSize: 12,
                color: "rgba(66, 192, 255, .3)"
              }
            }
          },
          {
            type: "value",
            nameTextStyle: {
              color: "#d2d2d2"
            },
            max: "3",
            min: "0",
            scale: true,
            position: "right",
            axisLine: {
              lineStyle: {
                color: "rgba(66, 192, 255, .3)"
              }
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              formatter: "{value} %", //右侧Y轴文字显示
              textStyle: {
                fontSize: 12,
                color: "#42C0FF"
              }
            }
          }
        ],
        series: [
          {
            name: "回访数量",
            type: "bar",
            barWidth: "25px",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#29acff"
                  },
                  {
                    offset: 1,
                    color: "#4bdfff"
                  }
                ])
              }
            },
            data: dataY1
          },
          {
            name: "满意率",
            type: "line",
            yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
            smooth: false, //平滑曲线显示

            symbol: "circle", //标记的图形为实心圆
            symbolSize: 8, //标记的大小
            itemStyle: {
              normal: {
                color: "#ffa43a",
                borderColor: "rgba(255, 234, 0, 0.5)", //圆点透明 边框
                borderWidth: 5
              }
            },
            lineStyle: {
              color: "#ffa43a"
            },

            data: dataY
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    ageChart() {
      let myChart = this.$echarts.init(document.getElementById("ageChart"));
      let dataX = ["25-28", "29-39", "40-49"];
      let dataY = [2.32, 2.38, 2.33];
      let dataY1 = [140000, 210000, 180000];
      let option = {
        grid: {
          top: "10%",
          bottom: "15%",
          left: "5%",
          right: "5%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: dataX,
          axisLine: {
            lineStyle: {
              color: "rgba(66, 192, 255, .3)"
            }
          },

          axisLabel: {
            textStyle: {
              color: "#33FFFF"
            }
          }
        },

        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: "#5FBBEB"
              }
            },
            axisLine: {
              lineStyle: {
                fontSize: 12,
                color: "rgba(66, 192, 255, .3)"
              }
            }
          },
          {
            type: "value",
            nameTextStyle: {
              color: "#d2d2d2"
            },
            max: "3",
            min: "0",
            scale: true,
            position: "right",
            axisLine: {
              lineStyle: {
                color: "rgba(66, 192, 255, .3)"
              }
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              formatter: "{value} %", //右侧Y轴文字显示
              textStyle: {
                fontSize: 12,
                color: "#42C0FF"
              }
            }
          }
        ],
        series: [
          {
            name: "回访数量",
            type: "bar",
            barWidth: "25px",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#29acff"
                  },
                  {
                    offset: 1,
                    color: "#4bdfff"
                  }
                ])
              }
            },
            data: dataY1
          },
          {
            name: "满意率",
            type: "line",
            yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
            smooth: false, //平滑曲线显示

            symbol: "circle", //标记的图形为实心圆
            symbolSize: 8, //标记的大小
            itemStyle: {
              normal: {
                color: "#ffa43a",
                borderColor: "rgba(255, 234, 0, 0.5)", //圆点透明 边框
                borderWidth: 5
              }
            },
            lineStyle: {
              color: "#ffa43a"
            },

            data: dataY
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    //鼠标移入停止轮播
    mouseEnter() {
      this.swiper.autoplay.stop();
    },
    //鼠标移出开始轮播
    mouseLeave() {
      // this.swiper.autoplay.start();
    },
    //点击切换轮播
    bannerTo(index) {
      this.activeIndex = index;
      this.swiper.slideTo(index, 1000, false);
    },
    //自动切换轮播
    slideChange() {
      var that = this;
      let index = this.swiper.activeIndex;
      that.bannerTo(index);
    }
  },
  mounted() {
    this.timeR();
    this.sexChart();
    this.ageChart();
  },
  beforeDestroy() {
    if (this.timeName) {
      clearInterval(this.timeName); // 在Vue实例销毁前，清除我们的定时器
    }
  }
};
</script>
<style lang="less" scoped>
.contanierbox {
  width: 100%;
  height: 100%;
  background: url("../assets/center/bg.png") no-repeat;
  background-size: 100% 100%;
  .clear {
    clear: both;
    float: none;
    height: 0;
  }
  .data_left {
    width: 16.5%;
    height: 100%;
    position: absolute;
    z-index: 3;
    left: 4%;
    top: 0;
    padding: 9% 0 10.5%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    div {
      color: #fff;
      // height: 196px;
      height: 28%;
      background: url("../assets/center/left_bg.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 15%;
      h3 {
        font-size: 16px;
        margin-bottom: 1%;
      }
      span {
        font-size: 12px;
      }
      img {
        width: 234px;
        margin-top: 7%;
      }
    }
    div:first-child {
      img {
        width: 163px;
        margin-left: 10%;
      }
    }
  }
  .data_right {
    color: #fff;
    width: 19%;
    height: 100%;
    position: absolute;
    z-index: 3;
    right: 4%;
    top: 0;
    padding: 9% 0 10.5%;
    .data_right_tab {
      height: 100%;
      background: url("../assets/center/right_bg.png") no-repeat;
      background-size: 100% 100%;
      padding: 10%;
      h3 {
        font-size: 16px;
        span {
          color: #ddc585;
        }
      }
      .right_top {
        height: 40%;
        margin-bottom: 25px;
        p {
          font-size: 12px;
          text-align: center;
          margin-top: 15px;
          margin-bottom: 10px;
        }
        .right_img {
          width: 100%;
          margin: 0 auto;
        }
      }
      .right_bottom {
        height: 60%;
        width: 100%;
        h3 {
          font-size: 16px;
          span {
            font-size: 12px;
            margin-left: 8px;
          }
        }
        .right_list {
          margin-top: 20px;
          li {
            width: 50%;
            text-align: left;
            float: left;
            margin-bottom: 15px;
            h3 {
              font-size: 12px;
              margin-bottom: 6px;
            }
            span {
              font-size: 20px;
              color: #dfc480;
              font-weight: bold;
            }
          }
        }
        .tab {
          display: flex;
          margin-top: 10px;
          h2 {
            font-size: 12px;
            margin-right: 15px;
          }
          .pagination > ul {
            li {
              cursor: pointer;
              margin-right: 8px;
              float: left;
              font-size: 12px;
              width: 40px;
              height: 16px;
              border-radius: 8px;
              border: 1px solid #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            li.swiper-pagination-customs-active {
              background: #dfc480;
              color: #333;
            }
          }
        }
        .mySwiper {
          height: 46%;
          width: 100% !important;
          .swiper1 {
            width: 100% !important;
            height: 100% !important;
          }
          .swiper2 {
            width: 100% !important;
            height: 100% !important;
          }
        }
        #sexChart {
          margin-top: 20px;
          width: 290px;
          height: 160px;
        }
        #ageChart {
          margin-top: 20px;
          width: 290px;
          height: 160px;
        }
      }
    }
    .img_flex{
      display: flex;
      align-items:center
    }
  }
  .data_center {
    width: 62%;
    position: absolute;
    z-index: 2;
    left: 19%;
    top: 12.5%;
    .center_title {
      margin: 0 auto 15px;
      width: 269px;
      height: 63px;
      background: url("../assets/center/center_bg1.png") no-repeat;
      background-size: 100% 100%;
      color: #eccc7c;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
    }
    .cir1 {
      width: 53%;
      margin: 0 auto;
      position: relative;
      > img {
        display: block;
      }
      .center_logo {
        width: 84.6%;
        position: absolute;
        top: 12%;
        left: 7.7%;
      }
      .c_title {
        background: #021060;
        border: 2px solid #729fd6;
        border-radius: 5px;
        width: 33.5%;
        height: 42px;
        color: #fff;
        font-size: 24px;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 33.25%;
        bottom: -10px;
      }
    }
    .arrow {
      display: flex;
      justify-content: center;
      margin-top: 14px;
      height: 23px;
      position: relative;
      .arrow_item {
        width: 167px;
        height: 23px;
      }
      .arrow_top {
        position: absolute;
        margin-left: -10px;
        animation: moveTop infinite 2s;
      }
      .arrow_bottom {
        position: absolute;
        margin-left: 10px;
        animation: moveBottom infinite 2s;
      }
      @keyframes moveTop {
        0% {
          transform: translateY(0);
        }

        50% {
          transform: translateY(-5px);
        }

        100% {
          transform: translateY(0);
        }
      }
      @keyframes moveBottom {
        0% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(5px);
        }
        100% {
          transform: translateY(0);
        }
      }
    }
    .cir2 {
      margin-top: 7px;
      position: relative;
      .c_title {
        background: #021060;
        border: 2px solid #729fd6;
        border-radius: 5px;
        width: 22%;
        height: 42px;
        color: #fff;
        font-size: 24px;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 39%;
        bottom: 12px;
      }
      .centerList {
        padding: 0 14.5%;
        position: absolute;
        top: 8px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        > div {
          width: 15%;
          p {
            color: #fff;
            font-size: 16px;
            text-align: center;
            margin-top: 12px;
          }
        }
        > div:nth-child(3) {
          animation: moveY 2s infinite;
          margin-top: -20px;
          p {
            margin-top: -12px;
            color: #dbc482;
            font-size: 18px;
            font-weight: bold;
          }
        }
        // .moveActive {
        //   animation: moveY 2s infinite;
        // }

        @keyframes moveY {
          0% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-1.5rem);
          }

          100% {
            transform: translateY(0);
          }
        }
      }
    }
    .arrowBox {
      display: flex;
      justify-content: space-around;
      margin-top: -16px;
    }
    .cir3 {
      width: 75%;
      margin: 0 auto;
      position: relative;
      .c_title {
        background: #021060;
        border: 2px solid #729fd6;
        border-radius: 5px;
        width: 35%;
        height: 42px;
        color: #fff;
        font-size: 24px;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 32.5%;
        bottom: 18px;
      }
    }
    .cir4 {
      width: 61%;
      margin: 0 auto 0;
      position: relative;
      .c_title {
        background: #021060;
        border: 2px solid #729fd6;
        border-radius: 5px;
        width: 30%;
        height: 42px;
        color: #fff;
        font-size: 24px;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 35%;
        bottom: -24px;
      }
      .cir4List {
        font-size: 18px;
        color: #fff;
        > div:first-child {
          position: absolute;
          top: 0px;
          left: 32%;
          text-align: center;
        }
        > div:last-child {
          position: absolute;
          top: 0px;
          text-align: center;
          right: 30%;
        }
        img {
          width: 63px;
          margin-bottom: 3px;
        }
      }
    }
    .jt {
      display: flex;
      justify-content: space-evenly;
      .arrow_down {
        display: flex;
        justify-content: center;
        margin-top: 14px;
        height: 23px;
        position: relative;
        .arrow_item {
          width: 17px;
          height: 23px;
        }
        .arrow_top {
          position: absolute;
          margin-left: -10px;
          animation: moveTop infinite 2s;
        }
        .arrow_bottom {
          position: absolute;
          margin-left: 10px;
          animation: moveBottom infinite 2s;
        }
        @keyframes moveTop {
          0% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-5px);
          }

          100% {
            transform: translateY(0);
          }
        }
        @keyframes moveBottom {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(5px);
          }
          100% {
            transform: translateY(0);
          }
        }
      }
      .arrow_down:first-child {
        margin-left: 27.5%;
      }
      .arrow_down:last-child {
        margin-right: 26.5%;
      }
    }
  }
}
</style>